<template>
    <div class="home">
      <div class="container">
        <div class="columns is-centered">
          <div class="column">
            <ValidationObserver v-slot="{ errors }" tag="div">
                <input-form
                  ref="form"
                  :errors="errors"
                  name="SHARCFileUpload"
                  @submit.prevent="handleSubmit"
                >
            <div class="content">
              <h1>Developer Checklist</h1>
              <div class="column">
                <vee-textbox
                  v-model="emailID"
                  error="This field is required for the status check"
                  name="input-email"
                  required
                  rules="required"
                  placeholder="Enter your Email"
                  type="text"
                />
              </div>
              <div class="column">
                <vee-textbox
                  v-model="verificationCode"
                  name="input-verification-code"
                  required
                  error="This field is required for the status check"
                  rules="required"
                  placeholder="Enter your verification code"
                  type="text"
                  @keyup.enter="handleSubmit"
                />
              </div>
              <div class="column is-2 is-offset-10">
                  <button
                    type="button"
                    class="button is-primary"
                    @click="handleSubmit"
                  >
                    Enter
                  </button>
                </div>
                <div v-html="statusResult"></div>
            </div>
            </input-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { getPropertyValueOrDefault } from "@/utilities/functions.js";
import buildPropertyInfoObject from "@/utilities/get-property-info-object.js";
import axios from "axios";

export default {
  name: 'DeveloperChecklist',
  data() {
    return {
      statusResult: null,
      project: null,
      emailID: null,
      verificationCode: null,
      recordID: null,
      projectAddress: null,
    };
  },
  methods: {
     handleSubmit(){
       var vData = this;
       const dataObject = buildPropertyInfoObject(
          vData.emailID,
          vData.verificationCode,
          "SHARC_GET_PROPERTY"
        );
        const requestObj = {
          table: "btpg5kytv",
          data: dataObject
        };
        axios
          .post(
            "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy-Reads",
            requestObj
          )
          .then(response => {
            const responseObject = getPropertyValueOrDefault(
              ["data", "record", "f"],
              response
            );
            console.log(responseObject);
            if(responseObject != null){
            vData.statusResult = getPropertyValueOrDefault(
              ["_text"],
              responseObject.find(i => i._attributes.id === "255")
            );
            if(Array.isArray(vData.statusResult)){
              vData.statusResult = vData.statusResult.join("");
            }
            vData.recordID = getPropertyValueOrDefault(
              ["_text"],
              responseObject.find(i => i._attributes.id === "3")
            );
            vData.projectAddress = getPropertyValueOrDefault(
              ["_text"],
              responseObject.find(i => i._attributes.id === "262")
            );
            }
            else{
              vData.statusResult = "Record Not Found"
            }
          }).catch(function(error) {
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            }
            vData.statusResult = "Request Timed Out. Please Try Again."
          });
       }
  }
}
</script>